import type { ContactInformationFormValues } from './ContactInformationSection.model';
import { contactInformationValidationSchema } from './ContactInformationSection.model';
import type { UserDetailsFormValues } from './UserDetailsSection.model';
import { userDetailsCreateValidationSchema } from './UserDetailsSection.model';

export type EmployeeCreateFormValues = UserDetailsFormValues & ContactInformationFormValues;

export const employeeCreateValidationSchema = userDetailsCreateValidationSchema.concat(
  contactInformationValidationSchema
);

export const employeeCreateInitialValues: EmployeeCreateFormValues = {
  employeeKey: '',
  name: '',
  titles: [],
  department: '',
  jobFunction: null,
  email1: '',
  email2: '',
  phoneNumber1: '',
  phoneNumber2: '',
  faxNumber1: '',
  faxNumber2: '',
  address1: '',
  address2: '',
};
